<template>
  <div v-if="isMobile" class="sec-default-bg">
      <MobileHeaderBack closeText></MobileHeaderBack>
      <div class="mobile-account__container mt-15rem">
        <div class="signup-form__title">{{$t('DELETE_ACCOUNT')}}</div>
        <DeleteAccount></DeleteAccount>
      </div>
  </div>
  <div v-else>
    <div class="account-content__wrapper">
      
      <DeleteAccount>
      </DeleteAccount>
    </div>
  </div>
</template>

<script>
import MobileHeaderBack from "@/components/mobile/HeaderBack.vue";
import DeleteAccount from "@/components/user/DeleteAccount.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    MobileHeaderBack,
    DeleteAccount,
  },
  data() {
    return {
      title: "",
    };
  },
  props: {
    isComponent: Boolean
  },
  created() {
    if(!this.isMobile && !this.isComponent) {
      setTimeout(() => {
        this.$router.push({
          name: 'Home'
        })
      }, 100)
    }
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters([
      "isMobile",
      "currentLocale",
      "isLogin",
      "userInfo",
      "currentLanguageObj",
    ]),
  },
  methods: {
    init() {
      this.title = this.$route.meta.name;
    },
  },
};
</script>

<style scoped>
@media(max-width: 768px) { /* for test */
  .signup-form__title {
    margin-bottom: 1.5rem;
  }
}
</style>
